import Axios, { Response } from '../utils/Axios';

export const CHAT_SENDER_HOTEL = 'HOTEL';
export const CHAT_SENDER_CLIENT = 'CLIENT';

export type ConciergeChatType = {
  conciergeId: number;
  name: string;
  latestChatTime: string;
  latestContent: string;
  customerUnreadMessageCount: number;
  hotelUnreadMessageCount: number;
};

export type ConciergeChatDetailType = {
  sender: string;
  read: boolean;
  origin: string;
  content_kr: string | null;
  sendAt: string;
  failed?:boolean;
};

const ConciergeController = {
  // 컨시어지 요청 리스트 조회
  getConciergeRequestList: async (oParams: any): Promise<Response> => {
    try {
      let sUrl = process.env.REACT_APP_API_KNOCKKNOCK_URL + '/concierge/getConciergeRequestList';
      const response: any = await Axios.post(sUrl, oParams);
      return response;
    } catch (err) {
      let oErr: any = err;
      return {
        ok: false,
        msg: '[getConciergeRequestList 오류]' + oErr.toString(),
        data: undefined,
        status: 500,
      };
    }
  },
  // 컨시어지 요청 상세 조회
  getConciergeRequestDetail: async (oParams: any): Promise<Response> => {
    try {
      let sUrl = process.env.REACT_APP_API_KNOCKKNOCK_URL + '/concierge/getConciergeRequestDetail';
      const response: any = await Axios.post(sUrl, oParams);
      return response;
    } catch (err) {
      let oErr: any = err;
      return {
        ok: false,
        msg: '[getConciergeRequestDetail 오류]' + oErr.toString(),
        data: undefined,
        status: 500,
      };
    }
  },
  writeMessage: async (oParams: any): Promise<Response> => {
    try {
      let sUrl = process.env.REACT_APP_API_KNOCKKNOCK_URL + '/concierge/writeMessage';
      const response: any = await Axios.post(sUrl, oParams);
      return response;
    } catch (err) {
      let oErr: any = err;
      return {
        ok: false,
        msg: '[writeMessage 오류]' + oErr.toString(),
        data: undefined,
        status: 500,
      };
    }
  },
};

export default ConciergeController;
